import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoSignatureDocumentBloc from "../../blocs/retirement/info-signature/REInfoSignatureDocumentBloc";




export default function REInfoSignatureDocumentPage() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        <h1 ref={pageGapRef} className="title mb-sm ml-lg-desktop">Documents précontractuels</h1>

        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop bg-blanc page-content p-lg">
            <REInfoSignatureDocumentBloc />
        </div>
      </div>
    
    )

}